import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@src/store/base-query';

export const ingredientsApi = createApi({
  reducerPath: 'ingredientsQueries',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    searchIngredients: builder.query({
      query: (params) => ({
        url: 'ingredients/get-ingredients',
        params: { params: JSON.stringify(params) },
      }),
      providesTags: ['Ingredients'],
    }),
    autocompleteIngredients: builder.mutation({
      query: (query) => ({
        url: 'ingredients/autocomplete',
        method: 'GET',
        params: { query },
      }),
      providesTags: ['Ingredients'],
    }),
    ingredientBlackListAdd: builder.mutation({
      query: ({ id }) => ({
        url: `users/ingredient-black-list-add/${id}`,
        method: 'POST',
      }),
    }),
    ingredientBlackListRemove: builder.mutation({
      query: ({ id }) => ({
        url: `users/ingredient-black-list-remove/${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useSearchIngredientsQuery,
  useAutocompleteIngredientsMutation,
  useIngredientBlackListAddMutation,
  useIngredientBlackListRemoveMutation,
} = ingredientsApi;
